import { Link } from "react-router-dom";
import { footerGroups, siteInfo } from "@/mocks/site";

export default function SiteFooter() {
  const year = 2026;
  return (
    <footer className="w-full bg-secondary-900 text-background-100">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <Link to="/" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                <i className="ri-focus-3-line text-lg" aria-hidden="true" />
              </span>
              <span className="font-heading text-lg font-bold tracking-wide text-background-50">
                {siteInfo.name}
              </span>
            </Link>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-300">
              {siteInfo.description}
              我们把散落的爆料、反转与官方通报按事件聚合，让每一条结论都留有可核对的来源。
            </p>
            <div className="mt-5 space-y-2 text-sm text-background-300">
              <p className="flex items-center gap-2">
                <span className="flex h-4 w-4 items-center justify-center text-accent-400" aria-hidden="true">
                  <i className="ri-mail-line text-base" />
                </span>
                <a href={`mailto:${siteInfo.email}`} className="transition-colors hover:text-accent-300">
                  {siteInfo.email}
                </a>
              </p>
              <p className="flex items-center gap-2">
                <span className="flex h-4 w-4 items-center justify-center text-accent-400" aria-hidden="true">
                  <i className="ri-time-line text-base" />
                </span>
                {siteInfo.workingHours}
              </p>
            </div>
          </div>

          {footerGroups.map((group) => (
            <nav key={group.title} aria-label={group.title} className="md:col-span-3 lg:col-span-2">
              <h4 className="font-heading text-sm font-bold tracking-wide text-background-50">
                {group.title}
              </h4>
              <ul className="mt-4 space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.path + link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-300 transition-colors hover:text-accent-300"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-bold tracking-wide text-background-50">
              求证原则
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm text-background-300">
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-blank-circle-fill mt-1.5 text-[6px] text-accent-400" aria-hidden="true" />
                结论以可查证材料为准
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-blank-circle-fill mt-1.5 text-[6px] text-accent-400" aria-hidden="true" />
                标注时间与最新进展
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-blank-circle-fill mt-1.5 text-[6px] text-accent-400" aria-hidden="true" />
                保护当事人隐私信息
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-blank-circle-fill mt-1.5 text-[6px] text-accent-400" aria-hidden="true" />
                公开参考来源便于复核
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-white/10 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} {siteInfo.fullName} · 内容仅供信息核验参考</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span>请以官方最新通报为准</span>
            <span className="hidden sm:inline">·</span>
            <span>转载请注明来源与更新时间</span>
          </p>
        </div>
      </div>
    </footer>
  );
}